import { WebSocketUrl, FocusBaseUrl, JoiApiUrl } from '../../Utils/Utils';

export const READY = {
  CONNECTING: WebSocket.CONNECTING,
  OPEN: WebSocket.OPEN,
  CLOSING: WebSocket.CLOSING,
  CLOSED: WebSocket.CLOSED,
} as const;

export const WS_URL = WebSocketUrl() || '';
export const FOCUS_BASE_URL = FocusBaseUrl() || '';
export const JOI_API_URL = JoiApiUrl() || '';

export const MAX_CHAT_INPUT_CHARS = 50000;